import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage } from "../../elements";
import { gtag } from "../../utils";
import "./style.scss";
const BrandImageList = props => {
	const { lang, rendering, fields, page } = props;
  const { list } = fields;
  const [listData, setListData] = useState([]);
  const isMobile = mobileIs();

  const toggle = (e, item) => {
    gtag('event', 'Component_info', {
      'component_name': 'BrandImageList',
      'page_title': page?.name
    });
    let list = JSON.parse(JSON.stringify(listData));
    list.forEach((el) => {
      if (el.id === item.id) {
        el.open = true;
      } else {
        el.open = false;
      }
    })
    setListData(list)
  }

  const leave = (e, item) => {
    let list = JSON.parse(JSON.stringify(listData));
    list.forEach((el) => {
      if (el.id === item.id) {
        el.open = false;
      }
    })
    setListData(list)
  }

  useEffect(() => {
    let listData = [];
    list.forEach((item, index) => {
      let dataItem = {
        fields: item.fields,
        id: item.id,
        image: isMobile ? item.fields.mobileImage : item.fields.pcImage,
        open: false
      }
      listData.push(dataItem);
    })
    setListData(listData);
  }, [])

  const rootClasses = classNames("c-brand-image-list", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className="c-brand-image-list__space">
        {listData.map((item, index) => (
          <div className={classNames("c-brand-image-list__space__item", index === 0 ? 'active' : '')} key={item.id} onMouseOver={(e) => toggle(e, item)} onMouseLeave={(e) => leave(e, item)}>
            <BackgroundImage {...item?.image} className={classNames("c-brand-image-list__space__item__image", item.open ? 'active' : '')} onClick={(e) => toggle(e, item)}>
              <RichText className={classNames("c-brand-image-list__space__item__image__title", item.open ? 'active' : '')} tag="div" field={item?.fields?.title} />
              <RichText className={classNames("c-brand-image-list__space__item__image__description", item.open ? 'active' : '')} tag="div" field={item?.fields?.description} />
            </BackgroundImage>
          </div>
        ))}
      </div>
    </div>
  );
};

export default 	BrandImageList;